export const removeOldDuplicatesBy = (data, getId) => {
  const entriesMap = new Map();
  data.forEach(current => {
    const id = getId(current);
    entriesMap.set(id, current);
  });
  return Array.from(entriesMap.values());
};
//# sourceMappingURL=removeOldDuplicatesBy.js.map